module.exports = __webpack_public_path__ + "static/media/audi.f7f26e55.jpg";